import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import styled, { css } from 'styled-components';
import { breakpoint, map } from '../breakpoint';
import { m, mt, ml, p } from '../spacing';
import { isList, isValidSpacing, getSpacingValue, mapFlexAlignment } from '../utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InlineWrapper = styled(({ as, space, collapseBelow, align, verticalAlign, spaceVertically, nowrap, ...rest })=>/*#__PURE__*/ _jsx("div", {
        ...rest
    })).attrs({
    'data-mesh-component': 'INLINE'
})`
  /* If stack is set to be a ul or ol we need to reset the default styling */
  ${({ as })=>as && isList(as) && css`
      ${m(0)};
      ${p(0)};
      list-style-type: none;
    `}
  display: flex;

  ${({ nowrap })=>nowrap ? 'flex-wrap: nowrap;' : 'flex-wrap: wrap;'}

  ${({ align })=>align && css`
      justify-content: ${mapFlexAlignment(align)};
    `}

  ${({ verticalAlign })=>verticalAlign && css`
      align-items: ${mapFlexAlignment(verticalAlign)};
    `}

  ${({ collapseBelow })=>collapseBelow ? css`
          /* When we are below the collapseBelow breakpoint: */
          ${breakpoint('xs', collapseBelow)`

        > * {
          width: 100%;

          &:not(:first-child) {
          ${({ space, spaceVertically })=>spaceVertically && map(space, (val)=>isValidSpacing(val) && css`
                  ${mt(val)};
                `)};
          }
        }
      `};
          /* When we are above the collapseBelow breakpoint: */
          ${breakpoint(collapseBelow)`
        /* Apply negative margin based on space prop */
        ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
                ${({ spaceVertically })=>spaceVertically && css`
                    margin-block-start: calc(0px - ${getSpacingValue(val)});
                  `}
                margin-inline-start: calc(0px - ${getSpacingValue(val)});
              `)};

        // Apply margin based on space prop to children
        > * {
          ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
                  ${({ spaceVertically })=>spaceVertically && css`
                      ${mt(val)};
                    `}
                  ${ml(val)};
                `)};
        }
      `};
        ` : css`
          /* Apply negative margin based on space prop */
          ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
                  ${({ spaceVertically })=>spaceVertically && css`
                      margin-block-start: calc(0px - ${getSpacingValue(val)});
                    `}
                  margin-inline-start: calc(0px - ${getSpacingValue(val)});
                `)};

          /* Apply margin based on space prop to children */

          > * {
            ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
                    ${({ spaceVertically })=>spaceVertically && css`
                        ${mt(val)};
                      `}
                    ${ml(val)};
                  `)};
          }
        `}
`;
export const Inline = (props)=>{
    const { children, space = 0, align = 'left', verticalAlign = 'top', spaceVertically = true, ...otherProps } = props;
    const ChildComponent = isList(props.as) ? 'li' : 'div';
    return /*#__PURE__*/ _jsx(InlineWrapper, {
        space: space,
        align: align,
        verticalAlign: verticalAlign,
        spaceVertically: spaceVertically,
        ...otherProps,
        children: Children.map(flattenChildren(children), (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child)) {
                return /*#__PURE__*/ _jsx(ChildComponent, {
                    children: child
                });
            }
            return null;
        })
    });
};
Inline.displayName = 'Inline';

//# sourceMappingURL=index.js.map